import Cookies from "js-cookie";
import { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { NavLink } from "react-router-dom";
import { store } from "../App";
import avatar from "../assets/images/avatar-2.jpg";
import { FetchSecurityMaster } from "../api/api";
import { Outlet, useNavigate } from "react-router-dom";

interface SidebarItemProps {
  to: string;
  icon: string;
  text: string;
}

const LeftNav = () => {
  const [token, setToken, userId, setUserId] = useContext(store);
  const [first, setfirst] = useState(userId);
  const [show, setShow] = useState(true);
  const [adminOpen, setAdminOpen] = useState(true);
  const toggleAdmin = () => setAdminOpen(!adminOpen);
  const selectedClient: any = Cookies.get("client");
  const [menuItems, setMenuItems] = useState<any>([]);
  const firstName: any = Cookies.get("firstName");
  const lastName: any = Cookies.get("lastName");
  const navigate = useNavigate();


  const handleToggle = (event: any) => {
    // 👇️ toggle shown state
    setShow((current) => !current);

    // 👇️ or simply set it to true
    // setIsShown(true);
  };

  useEffect(() => {
    FetchSecurityMaster(
      "ProductMenuList",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setMenuItems(response);
    });
    
  }, [])
  
  useEffect(() => {
    if (!Cookies.get("newJwt")) {
      return navigate("/");
    }
  }, [navigate]);



const SidebarItem: React.FC<SidebarItemProps> = ({ to, icon, text }) => {
  return (
    <li className="sidebar-item">
      <NavLink className="sidebar-link" to={to}>
        <span className="align-middle">
          <i className={`align-middle me-2 fas fa-fw ${icon}`}></i>
          {text}
        </span>
      </NavLink>
    </li>
  );
};

  return (
    <nav
      id="sidebar"
      className="sidebar"
      style={{
        marginLeft: show ? "0px" : "-250px",
      }}
    >
      <div className="position-relative">
        <div className="position-absolute top-0 end-0 start-100 translate-bottom m-3">
          <span className="sidebar-toggle d-flex me-2" onClick={handleToggle}>
            <i className="hamburger align-self-center"></i>
          </span>
        </div>
      </div>

      <span className="sidebar-brand">AKRA</span>
      <div className="sidebar-content">
        <div className="sidebar-user">
          <img
            src={avatar}
            className="img-fluid rounded-circle mb-2"
            alt="Linda Miller"
          />
          <div className="fw-bold">
            {firstName} {lastName}
          </div>

          {/* <small>Front-end Developer</small> */}
        </div>
        <ul className="sidebar-nav">
          {menuItems.map((menuItem: any, index: any) => {
            // Check if webPageStatus is "Y" before rendering the SidebarItem
            if (menuItem.webPageStatus === "Y") {
              return (
                <SidebarItem
                  key={index}
                  to={menuItem.toURL.replace(/\s/g, "")}
                  icon={menuItem.icon} // Assuming you want to set the icon for all menu items to "fa-users"
                  text={menuItem.webPageFile}
                />
              );
            } else {
              return null; // If webPageStatus is not "Y", don't render the menu item
            }
          })}
        </ul>
      </div>
    </nav>
  );
};

export { LeftNav };
